import Image from "next/image";
import { Link } from "../../../navigation";

export function NewsCardGroup({
  children,
  href = "",
  buttonText = "",
}: {
  children: React.ReactNode;
  href?: string;
  buttonText?: string;
}) {
  return (
    <>
      <div className="row">{children}</div>
      {href && (
        <div className="text-center mt-3">
          <Link data-appearance="secondary" href={href}>
            {buttonText}
          </Link>
        </div>
      )}
    </>
  );
}

export default function NewsCard({ imagePath, label, title, href, mode }) {
  return (
    <div className="col-md-4 mb-4">
      <div className="news-card news-card--academy-and-news border-radius position-relative">
        <div className="news-card-image-wrap overflow-hidden">
          {imagePath && (
            <Image
              className="news-card-image"
              src={imagePath}
              alt=""
              quality={90}
              width={400}
              height={400}
              style={{ objectFit: "cover", objectPosition: "center" }}
              unoptimized={imagePath?.endsWith(".svg")}
            />
          )}
        </div>
        <div className="news-card__content">
          <small className="d-block news-card__content__first-line">
            {label}
          </small>
          {href ? (
            <Link href={href} className="news-card__link">
              <p className="fw-bold">{title}</p>
            </Link>
          ) : (
            <p className="fw-bold">{title}</p>
          )}
        </div>
      </div>
    </div>
  );
}
